import React, { Component, Dispatch } from 'react';

import { Common } from '../../core/common';
import { IAction, IAppState } from '../../models/action/core';
import { connect } from 'react-redux';
import { Log } from 'ng2-logger';
import Translator from '../../core/i18n';
import { Modal } from 'reactstrap';
import * as NotificationPageAction from '../../store/actions/notification';
import { withRouter } from 'react-router-dom';
import { IHeaderOptions } from '../../models/components/header-options';
import moment from 'moment';
import Paginate from '../table/paginate';

const T = Translator.create();
const _logger = Log.create('Home Box Messages');
let _common: Common;
const noNotificationImage = `${process.env.PUBLIC_URL}/images/notifications/no_notification.png`;
export class CNotifications extends Component<any> {

    public state = {
        notificationPage : 1
    }
    constructor(props: any) {
        super(props);
        _common = new Common();
    }

    public componentDidMount()
    {
        this.callApi(this.state.notificationPage);

    }

    callApi = (page: number) =>
    {
        this.props.dispatch(NotificationPageAction.GetNotificationsAll(false, 0, 10, page));

    }

    public clickToDownload = (message: string) => {
        const messageSplit = message.split('-FileDownloadLink:');
        let linkUrl: string = window.appSettings.API_URL;

        if (messageSplit.length > 1) {
            const filePath = messageSplit[1];
            if (filePath.startsWith('https:')) {
                linkUrl = filePath;
                _common.DownloadLink(linkUrl, '');
            } else if (filePath.startsWith('zip:')){
                let zipurl = filePath.replace('zip:','');
                linkUrl += '/' + zipurl
                _common.DownloadZip(linkUrl, T.t('r_assignment_files'))
            } else {
                if (filePath.startsWith('/')) {
                    linkUrl += filePath;
                } else {
                    linkUrl += '/' + filePath;
                }
                _common.DownloadLink(linkUrl, '');
            }


        }
    };

    public onPageChange = async (page: number) => {
        this.state.notificationPage = page;
        this.setState(this.state);
        this.callApi(page);
    };

    viewData = () =>
        {

            let data = [];

            if (this.props.notification.length > 0)
                {

                    this.props.notification.map( (x:any) => {
                            data.push (
                                <div className='conversation-popup pt-2 position-relative' style={{fontSize: "14px"}}>
                                    <div className='white-box m-0 p-1'><div className="d-flex justify-content-between p-0">
                                    <div className='col-3 text-center d-flex justify-content-center align-items-center'>
                                        {x.notificationType == 1 ?
                                        (<div className=' tag-program ml-2 text-center text-wrap p-1' style={{fontSize: "12px", fontWeight: "unset"}}>{T.t('r_gen_success')}</div>)
                                        :
                                        (<div className='small-tag tag-web text-center text-wrap p-1' style={{fontSize: "12px", fontWeight: "unset"}}>{T.t('r_gen_enrollment_failed')}</div>)
                                        }
                                        </div>
                                    <div className='col-6 d-flex text-start' style={{cursor: "pointer"}}  onMouseDown={this.clickToDownload.bind(this, x.message)}>{T.t(x.message.split('-FileDownloadLink:')[0], { 0: x.message.split('-FileDownloadLink:')[1] })}</div>
                                        <div className='col-3 text-center d-flex justify-content-center align-items-center'>{moment(x.cretedDate).format('DD.MM.YYYY HH:mm')}</div>
                                        </div>
                                    </div>
                                </div>
                                 )
                    })
                }
                else
                {
                    data.push(  <div  style={{fontSize: "14px"}}>
                    <div className='white-box m-0 p-1'>

                        <div className="d-flex justify-content-center p-0"> <img
                        src={noNotificationImage}
                        alt="newActivityCount"
                    /></div>
                     <div className="d-flex justify-content-center p-0"><p style={{ margin: '1em' }}>{T.t('r_notification_not_found')}</p></div>
                     </div> </div>)
                }

                return data;
        }

    public render() {


        return (
            <Modal
            className="pt-0 mx-auto"
            style={{ maxWidth: '90vw',margin:'0 auto' }}
            isOpen={true}
            fade={true}
            backdrop={'static'}>
            <div className="white-box shadow">
            <div className="d-flex justify-content-between white-box-header">
                    <div>
                        <h2>
                            {T.t('r_notifications')}
                        </h2>
                    </div>
                    <div className="align-self-center">

                        <a  onMouseDown={event =>this.props.onNotificatinClick(false)} >
                            <i className="material-icons ml-2 align-middle">close</i>
                        </a>
                    </div>
                </div>

                {this.viewData()}

            </div>

            {this.props.notification.length>0 && this.props.totalCount > 10 && (
                                    <Paginate
                                    filters={{
                                        skip: 0,
                                        take: 10,
                                        page: this.state.notificationPage,
                                        total: this.props.totalCount
                                    }}
                                    onPageChange={this.onPageChange}
                                     />
                     )}
            </Modal>
        );
    }
}


const mapStateToProps = (state: IAppState, ownProps: IHeaderOptions): IHeaderOptions => {
    if (!state) {
        return ownProps;
    }

    const newProps: IHeaderOptions =  {...ownProps, ... {
        notification: state.notification.notificationsAll,
        totalCount: state.notification.unreadNotificationCountAll
    }};

    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = next.notification.notificationsAll === prev.notification.notificationsAll &&
    next.notification.unreadNotificationCountAll === prev.notification.unreadNotificationCountAll;
    return ret;
};


const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};



const Notifications = connect(mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    })(CNotifications);

 export default withRouter<any, any>(Notifications);
